const LocationsSection = () => {
  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-[#2D5016] mb-4">
            Le Nostre Sedi
          </h2>
          <p className="text-gray-600 text-lg">
            Presenti nel cuore dell'Italia per servirti al meglio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-[#2D5016] rounded-full mb-6">
                <i className="ri-map-pin-line text-white text-3xl"></i>
              </div>
              <p className="text-sm font-semibold text-[#2D5016] uppercase tracking-wider mb-2">
                Sede Legale
              </p>
              <h3 className="text-3xl font-serif text-[#2D5016] mb-2">
                Piazza Vetra 17
              </h3>
              <p className="text-xl text-gray-600 mb-6">
                20123 Milano (MI)
              </p>
              
              <div className="space-y-3 mb-6">
                <div className="flex items-center text-gray-600">
                  <i className="ri-phone-line mr-3 text-[#2D5016]"></i>
                  <span>+39 02 1234 5678</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <i className="ri-mail-line mr-3 text-[#2D5016]"></i>
                  <span>info@agro-innovazioni.it</span>
                </div>
              </div>

              <div className="h-64 rounded-2xl overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.4!2d9.1889!3d45.4585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDI3JzMwLjYiTiA5wrAxMScyMC4wIkU!5e0!3m2!1sit!2sit!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Sede Legale Milano"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-[#8B9D7C] rounded-full mb-6">
                <i className="ri-building-line text-white text-3xl"></i>
              </div>
              <p className="text-sm font-semibold text-[#2D5016] uppercase tracking-wider mb-2">
                Ufficio Commerciale
              </p>
              <h3 className="text-3xl font-serif text-[#2D5016] mb-2">
                Piazza Jan Palach 9L
              </h3>
              <p className="text-xl text-gray-600 mb-6">
                Sassuolo (MO)
              </p>
              
              <div className="space-y-3 mb-6">
                <div className="flex items-center text-gray-600">
                  <i className="ri-phone-line mr-3 text-[#2D5016]"></i>
                  <span>+39 0536 123 456</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <i className="ri-mail-line mr-3 text-[#2D5016]"></i>
                  <span>commerciale@agro-innovazioni.it</span>
                </div>
              </div>

              <div className="h-64 rounded-2xl overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2850.5!2d10.7833!3d44.5433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDMyJzM1LjkiTiAxMMKwNDYnNTkuOSJF!5e0!3m2!1sit!2sit!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ufficio Commerciale Sassuolo"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Vuoi visitarci o hai bisogno di maggiori informazioni?
          </p>
          <a
            href="/contatti"
            className="inline-flex items-center px-8 py-4 bg-[#2D5016] text-white rounded-full text-base font-medium hover:bg-[#3d6b1e] transition-colors cursor-pointer whitespace-nowrap"
          >
            Contattaci
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;